<template>
  <w-sliding-popup ref="regularCheckDetailInfoPopup" :defaultContent="false" :type="popupType" :title="`점검내용 상세보기 ${popupInfo.objName}`" @close="onClose">
    <div class="body-content" slot="content" style="height: 95%;">
      <el-row style="padding-bottom:10px;">
        <el-radio-group v-model="currentCmp" @change="selectCmpType" size="small">
          <el-radio-button v-for="checkItem in checkItemLabelList" :label="checkItem.label" :key="checkItem.name" />
        </el-radio-group>
      </el-row>
      <el-scrollbar ref="scrollbar" class="bar-visible">
        <div ref="cmpWrapper" :class="$style['cmp-wrapper']">
          <el-row v-for="checkItem in checkItemLabelList" :key="checkItem.name" class="mr-b25" style="min-height: 300px;" :ref="checkItem.name">
            <el-row class="title-bar" type="flex" justify="space-between">
              <div class="title-h4">{{checkItem.label}}</div>
              <div v-if="checkItem.name !== 'interface'">
                <ul class="diff-legend-box">
                  <li><span class="item added"></span>추가</li>
                  <li><span class="item modified"></span>변경</li>
                  <li><span class="item deleted"></span>삭제</li>
                </ul>
                <el-radio-group class="ordinary cmp-margin-left" v-model="changeDataFlag[checkItem.name]">
                  <el-radio-button :label="true">변경내역만 보기</el-radio-button>
                  <el-radio-button :label="false">전체 보기</el-radio-button>
                </el-radio-group>
              </div>
            </el-row>
            <hr class="mr-b20" style="margin-top:0;" />
            <el-row v-if="!isNil(checkItemHist[checkItem.name.toUpperCase()])" type="flex">
              <div style="width: 100%;" v-if="checkItemHist[checkItem.name.toUpperCase()].changeFlag === '0' || checkItemHist[checkItem.name.toUpperCase()].changeFlag === '2'"
                v-html="checkItemHist[checkItem.name.toUpperCase()].changeMessage"></div>
              <div v-else-if="checkItem.name === 'interface'" style="width: 100%;">
                <div style="float:left; width:calc(50% - 7.5px);">
                  <div class="dot-title title-bar ">변경 전 인터페이스 정보</div>
                  <w-interface-change-table style="width:100%;" :pagination-flag="false" :interface-change-info="JSON.parse(checkItemHist[checkItem.name.toUpperCase()].changeMessage)" />
                </div>
                <div style="float:right; width:calc(50% - 7.5px)">
                  <div class="dot-title title-bar ">변경된 인터페이스 정보</div>
                  <w-interface-change-table style="width:100%;" :pagination-flag="false" :interface-change-info="JSON.parse(checkItemHist[checkItem.name.toUpperCase()].diffMessage)" />
                </div>
                <!-- <w-interface-change-table v-if="changeDataFlag[checkItem.name]" :pagination-flag=false :interface-change-info="JSON.parse(checkItemHist[checkItem.name.toUpperCase()].changeMessage)" />
                <w-interface-change-table v-else-if="!changeDataFlag[checkItem.name]" :pagination-flag=false :interface-change-info="JSON.parse(checkItemHist[checkItem.name.toUpperCase()].diffMessage)" /> -->
              </div>
              <div style="width: 100%;" v-else-if="!changeDataFlag[checkItem.name]" v-html="checkItemHist[checkItem.name.toUpperCase()].changeMessage"></div>
              <div style="width: 100%;" v-else-if="changeDataFlag[checkItem.name]" v-html="checkItemHist[checkItem.name.toUpperCase()].diffMessage"></div>
            </el-row>
          </el-row>
        </div>
      </el-scrollbar>
    </div>
  </w-sliding-popup>
</template>

<script>
import moment from 'moment';
import isNil from 'lodash/isNil';
import forEach from 'lodash/forEach';
import findIndex from 'lodash/findIndex';
import msgUtil from '@/utils/message';
import netdeviceInfoAPI from '@/api/config/netdevice/netdevice-info';
import WInterfaceChangeTable from '@/views/config/group/netdevice/components/popup/InterfaceChangeTable';

// TODO: item_id, change_flag 상수로 관리 필요.
export default {
  name: 'WRegularCheckDetailInfoPopup',
  components: {
    WInterfaceChangeTable,
  },
  // props: {
  //   popupInfo: {
  //     type: Object,
  //     default: () => ({}),
  //   },
  // },
  data() {
    return {
      popupType: 'full',
      activeTab: 'device',
      checkItemLabelList: [
        { label: '장비변경', name: 'device' },
        { label: '인터페이스', name: 'interface' },
        { label: '컨피그', name: 'config' },
        { label: '하드웨어', name: 'hardware' },
        { label: '라우팅', name: 'routing' },
        { label: 'VLAN', name: 'vlan' },
        { label: 'STP', name: 'stp' },
        { label: 'IP', name: 'ip' },
      ],
      checkItemList: ['DEVICE', 'INTERFACE', 'CONFIG', 'HARDWARE', 'ROUTING', 'VLAN', 'STP', 'IP'],
      currentCmp: '장비변경',
      checkItemHist: {},
      changeDataFlag: {
        device: false,
        interface: false,
        config: false,
        hardware: false,
        routing: false,
        vlan: false,
        stp: false,
        ip: false,
      },
    };
  },
  computed: {
    showSettingView() {
      return this.$store.state.common.showSettingView;
    },
    visible() {
      return this.$store.state.popup.showRegularCheckDetailInfoPopup;
    },
    popupInfo() {
      return this.$store.state.popup.regularCheckDetailInfoPopupParams;
    },
  },
  watch: {
    visible: {
      handler(value) {
        if (value) {
          this.open();
        } else {
          this.close();
        }
      },
    },
  },
  beforeDestroy() {
    if (this.visible) {
      this.close();
    }
  },
  methods: {
    isNil,
    open() {
      this.$refs.regularCheckDetailInfoPopup.open();
      this.popupType = this.showSettingView ? 'setting' : 'full';
      this.changeDataFlag = {
        device: false,
        interface: false,
        config: false,
        hardware: false,
        routing: false,
        vlan: false,
        stp: false,
        ip: false,
      };
      this.loading = true;
      const startDatetime = moment(this.popupInfo.checkDatetime).subtract(5, 'minutes').toDate();
      const endDatetime = moment(this.popupInfo.checkDatetime).add(5, 'minutes').toDate();
      const params = {
        histSeq: this.popupInfo.histSeq,
        objId: this.popupInfo.objId,
        startDatetime: startDatetime.getTime(),
        endDatetime: endDatetime.getTime(),
      };
      netdeviceInfoAPI.getNetdeviceRegularCheckDetailInfo(params).then((response) => {
        if (response.data.success) {
          const data = response.data.data;
          if (!isNil(data)) {
            forEach(data, (value, key) => {
              this.changeDataFlag[key.toLowerCase()] = value.changeFlag === '1';
            });
          }
          const checkItemHist = {};
          forEach(this.checkItemList, (item) => {
            if (isNil(data[item])) {
              checkItemHist[item] = {
                itemId: item,
                changFlag: 2,
                changeMessage: '정보수집을 하지 못했습니다.',
              };
            } else {
              checkItemHist[item] = data[item];
            }
          });
          this.checkItemHist = checkItemHist;
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '점검 내용', false));
        }
      }).catch(() => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '점검 내용', false));
      }).finally(() => {
        this.loading = false;
      });
    },
    close() {
      this.$refs.regularCheckDetailInfoPopup.close();
    },
    onClose() {
      this.currentCmp = '장비변경';
      this.$refs.scrollbar.wrap.scrollTop = 0;
      this.$store.dispatch('closeRegularCheckDetailInfoPopup');
    },
    /**
     * 버튼 클릭 시 해당 컴포넌트로 이동
     * @author kimjy
     * @param  {String} 선택된 라디오버튼 라벨
     */
    selectCmpType(componentType) {
      const index = findIndex(this.checkItemLabelList, ['label', componentType]);
      const cmp = this.$refs[this.checkItemLabelList[index].name][0];
      this.$refs.scrollbar.wrap.scrollTop = cmp.$el.offsetTop - this.$refs.cmpWrapper.offsetTop;
    },
  },
};
</script>

<style module>
.cmp-wrapper {
  height: 730px;
  padding: 4px;
  margin-top: 5px;
  width: 100%;
  /* overflow-y: auto; */
}
</style>



// WEBPACK FOOTER //
// src/components/popup/RegularCheckDetailInfoPopup/index.vue